export default __webpack_public_path__ + "static/media/kinetic-cta-mobile.6026c6fc.svg";